import { render, staticRenderFns } from "./CustomDataTable2.vue?vue&type=template&id=21d42100&scoped=true&"
import script from "./CustomDataTable2.vue?vue&type=script&lang=js&"
export * from "./CustomDataTable2.vue?vue&type=script&lang=js&"
import style0 from "./CustomDataTable2.vue?vue&type=style&index=0&id=21d42100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d42100",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCard,VCardActions,VDataTable,VDivider,VPagination})
